export default __webpack_public_path__ + "static/media/uploader-abbottNeo-problem-2.657fff1f.png";